<template>
  <div class="edit-live-review-consumption-history-table">
    <b-input
      v-model="keyword"
      class="mb-5"
      type="text"
      placeholder="Rechercher un tracker, un dossard ou un live"
      icon="search"
      :icon-right="keyword ? 'times-circle' : ''"
      icon-right-clickable
      @icon-right-click="keyword = ''"
    />
    <o-table
      :items="visibleRows"
      :loading="loading"
      :draggable="false"
      :stickyHeader="true"
      defaultSort="label"
    >
      <b-table-column
        v-slot="{ row }"
        sortable
        field="label"
        label="Tracker"
        cell-class="is-narrow"
      >
        <router-link
          target="_blank"
          :to="{ name: 'queclinkTracker.edit', params: { id: row.trackerId, tab: 'statistics' } }"
        >
          {{ row.label }}
        </router-link>
      </b-table-column>
      <b-table-column
        v-for="(columnLabel, index) in columnLabels"
        :key="columnLabel"
        v-slot="{ row }"
        sortable
        :field="columnLabel"
        :label="columnLabel"
        :custom-sort="sortByInitialPercentage(index)"
        cell-class="is-narrow"
      >
        <div v-if="row.cells[index]" class="is-flex is-flex-direction-column">
          <span class="is-flex is-align-items-center has-text-dark">
            <span
              v-if="row.cells[index].initialPercentage !== null"
              :class="{
                'has-text-danger': row.cells[index].initialPercentage < lowInitialBatteryPercentage,
              }"
            >
              {{ row.cells[index].initialPercentage }} %
            </span>
            <span v-else>{{ EMPTY_VALUE }}</span>
            <span class="has-text-grey-light mx-2">·</span>
            <span>{{ formatVehicleNumber(row.cells[index].vehicleNumber) }}</span>
          </span>
          <router-link
            v-if="row.cells[index].liveId"
            class="is-size-7 has-text-grey-light is-underlined edit-live-review-consumption-history-table__live-name"
            :title="row.cells[index].liveName"
            target="_blank"
            :to="{
              name: 'live.edit.informations',
              params: { id: row.cells[index].liveId, tab: 'review' },
            }"
          >
            {{ row.cells[index].liveName }}
          </router-link>
          <span
            v-else
            class="is-size-7 has-text-grey-light edit-live-review-consumption-history-table__live-name"
            :title="row.cells[index].liveName"
          >
            {{ row.cells[index].liveName }}
          </span>
          <span class="is-size-7 has-text-grey-light">{{ row.cells[index].startedAt }}</span>
        </div>
        <template v-else>{{ EMPTY_VALUE }}</template>
      </b-table-column>
      <template #empty>
        <div class="has-text-grey has-text-centered">
          {{ keyword ? 'Tracker introuvable.' : 'Aucun tracker sur ce live.' }}
        </div>
      </template>
    </o-table>
  </div>
</template>

<script>
import OTable from '@components/Table.vue'
import { stringNormalizer } from '@helpers/stringNormalizer'

const EMPTY_VALUE = '—'

export default {
  name: 'EditLiveReviewConsumptionHistoryTable',

  components: {
    OTable,
  },

  props: {
    rows: {
      type: Array,
      required: true,
    },
    columnLabels: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    lowInitialBatteryPercentage: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      keyword: '',
    }
  },

  computed: {
    visibleRows() {
      if (!this.keyword) {
        return this.rows
      }

      const keyword = stringNormalizer(this.keyword).toLowerCase()

      return this.rows.filter((row) =>
        [row.label, ...row.cells.flatMap(this.searchableCellValues)].some((value) =>
          stringNormalizer(value || '')
            .toLowerCase()
            .includes(keyword),
        ),
      )
    },
  },

  created() {
    this.EMPTY_VALUE = EMPTY_VALUE
  },

  methods: {
    formatVehicleNumber(vehicleNumber) {
      return vehicleNumber ? `N°${vehicleNumber}` : EMPTY_VALUE
    },

    searchableCellValues(cell) {
      return cell ? [cell.liveName, cell.vehicleNumber] : []
    },

    sortByInitialPercentage(index) {
      return (left, right, isAscending) => {
        const leftPercentage = left.cells[index]?.initialPercentage ?? null
        const rightPercentage = right.cells[index]?.initialPercentage ?? null

        if (leftPercentage === null || rightPercentage === null) {
          return (leftPercentage === null ? 1 : 0) - (rightPercentage === null ? 1 : 0)
        }

        return isAscending ? leftPercentage - rightPercentage : rightPercentage - leftPercentage
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-live-review-consumption-history-table {
  &__live-name {
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
